import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IsMobileService {

  constructor() { }

  getIsMobile() {
    return window.innerWidth < 768;
  }
}
